<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
	<div>
		<egranty-input-field-popup
			:is-open.sync="addTeamVisible"
			:label="'Nazwa zespołu'"
			:title="'Utwórz zespół'"
			@save="addTeam"
			@cancel="addTeamVisible = false"
		></egranty-input-field-popup>

		<egranty-input-field-popup
			:is-open.sync="editNameVisible"
			:label="'Nowa nazwa zespołu'"
			:title="'Zmiana nazwy zespołu'"
			@save="editFinished"
			@cancel="editNameVisible = false"
		></egranty-input-field-popup>

		<egranty-table
			:table-name="'Zespoły'"
			:headers="headers"
			:items="teams"
			:toolbar-action-name="'Dodaj zespół'"
			:row-actions="actions"
			@toolbarAction="openAddTeam"
			@editName="editName"
			@deleteTeam="deleteTeam"
		></egranty-table>

		<egranty-autocomplete
			:is-visible="addTeamUserVisible"
			:headers="userHeaders"
			:possibilities="possibilities"
			:filters="columnFilters"
			title="Dodaj nową osobę do zespołu"
			hint=""
			search-field-label="Osoba"
			@cancel="endAddingUsers"
			@save="addTeamUser"
		></egranty-autocomplete>

		<v-card>
			<v-toolbar>
				<v-toolbar-title>Składy zespołów</v-toolbar-title>
			</v-toolbar>
			<v-expansion-panel>
				<v-expansion-panel-content
					v-for="(item,i) in teams"
					:key="item.name"
				>
					<template v-slot:header>
						<div>{{item.name}}</div>
					</template>

					<egranty-table
						:key="keyValue"
						:table-name="'Skład'"
						:toolbar-action-name="'Dodaj osobę'"
						:headers="usersTableHeaders"
						:items="teamUsers[i]"
						:row-actions="actionsUsers"
						@deleteUser="(item)=>{deleteUser(item.id)}"
						@toolbarAction="openAddTeamUser(item)"
						@promote="(item) => {promoteToLeader(i, item);}"
					>
					</egranty-table>


				</v-expansion-panel-content>
			</v-expansion-panel>

		</v-card>

	</div>
</template>

<script>
	import EgrantyTable from "../../../genericComponents/EgrantyTable";
	import EgrantyInputFieldPopup from "../../../genericComponents/EgrantyInputFieldPopup";
	import EgrantyAutocomplete from "../../../genericComponents/EgrantyAutocomplete";
	import {Team} from "../../../api/generated/Team";
	import {TeamUsers} from "../../../api/generated/TeamUsers";

	export default {
		name: "TeamsView",
		components: {EgrantyAutocomplete, EgrantyInputFieldPopup, EgrantyTable},
		methods: {

			openAddTeam() {
				this.addTeamVisible = true;
			},

			openAddTeamUser(item) {
				this.editedItem = item;

				TeamUsers.getTeamUsersToAdd(
					this,
					item.id,
					response => {
						this.addTeamUserVisible = true;
						this.possibilities = response;
					});
			},

			promoteToLeader(i, item) {
				TeamUsers.putPromoteToLeader(
					this,
					item.id,
					() => {
						this.refresh();
					},
				);
			},

			addTeam(name) {
				Team.postTeam(this,
					this.$route.params.id,
					name,
					() => {
						this.addTeamVisible = false;
						this.refresh();
					},
				);
			},

			addTeamUser(item) {
				TeamUsers.postTeamUser(
					this,
					item.id,
					this.editedItem.id,
					() => {
						this.addTeamUserVisible = false;
						this.refresh();
					},
				);

			},

			endAddingUsers() {
				this.addTeamUserVisible = false;
			},

			deleteTeam(item) {
				this.$confirm("Czy na pewno chcesz usunąć zespół?", {
					color: "lightred",
					icon: "delete",
					title: "Usunięcie zespołu",
					width: 500
				})
					.then(result => {
						if (result) {
							Team.deleteTeam(this, item.id, successResponse => {
								this.$messagesBus.$emit("success", "Zespół został pomyślnie usunięt", successResponse);
								this.refresh();
							}, errorResponse => {
								this.$messagesBus.$emit("error", "Nie udało się usunąć zespołu. Nie można tego zrobić jeśli przypisano do niego jakikolwiek kraj. Sprawdź też, czy nie przydzielono do niego wniosków do zaopiniowania.", errorResponse);
							});
						}
					});
			},

			deleteUser(id) {
				TeamUsers.deleteTeamUser(
					this,
					id,
					(onSuccess) => {
						this.$messagesBus.$emit("success", "Członek komisji został pomyślnie usunięty", onSuccess);
						this.refresh();
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się usunąć członka zespołu. Sprawdź czy " +
							"nie ma przydzielonych opinii lub nie jest przewodniczącym zespołu albo osobą protokołującą " +
							"w jednej z opinii końcowych.", errorResponse);
					}
				);
			},

			editName(item) {
				this.editedItem = item;
				this.editNameVisible = true;
			},


			editFinished(newName) {
				Team.putTeam(
					this,
					this.$route.params.id,
					this.editedItem.id,
					newName,
					succResponse => {
						this.editNameVisible = false;
						this.$messagesBus.$emit("success", "Zmieniono nazwę zespołu", succResponse);
						this.refresh();
					},
					errResponse => {
						this.$messagesBus.$emit("error", errResponse.errors[0], errResponse);
					});
			}
			,

			refresh() {
				Team.getTeams(
					this,
					this.$route.params.id,
					response => {
						let i;
						this.teams = response;
						let left = response.length;
						for (i = 0; i < this.teams.length; i++) {
							let j = i;
							TeamUsers.getTeamUsers(
								this,
								this.teams[j].id,
								response => {
									this.teamUsers[j] = response;
									left--;
									if (left === 0) {
										this.keyValue++;
									}
								},
							);
						}

					});
			},
		},

		data() {
			return {
				headers: [
					{text: "Nazwa zespołu", value: "name"},
				],

				usersTableHeaders: [
					{text: "Imię", value: "name", sortable: false},
					{text: "Nazwisko", value: "surname", sortable: false},
					{text: "Email", value: "email", sortable: false},
					{
						text: "Rola w zespole",
						value: "leaderCaption",
						sortable: false,
						postProcessor: function (item) {
							return item.leader === true ? "Przewodniczący zespołu" : "-";
						},
					},
				],

				columnFilters: {
					"id": false,
					"Description": false,
				},

				userHeaders: {
					name: "Imię",
					surname: "Nazwisko",
					email: "Email",
				},

				teams: [],

				teamUsers: [],

				possibilities: [],

				editedItem: {},

				keyValue: 0,

				addTeamUserVisible: false,

				addTeamVisible: false,

				editNameVisible: false,

				actions: [
					{name: "editName", icon: "edit"},
					{name: "deleteTeam", icon: "delete"},
				],

				actionsUsers: [
					{
						name: "promote",
						icon: "supervisor_account",
						label: "Wyznacz na przewodniczącego",
						isDisabled: function (item) {
							return item.leader || !(item.agencyContestRole === 'SECRETARY' || item.agencyContestRole === 'MAIN_SECRETARY'
								|| item.agencyContestRole === 'LEADER' || item.agencyContestRole === 'MAIN_LEADER');
						},
					},
					{name: "deleteUser", icon: "delete", label: "Usuń z zespołu"},

				],
			};
		}
		,

		mounted() {
			this.refresh();
		},
	};
</script>

<style scoped>

</style>
